import React, { useState, useEffect, useCallback } from 'react';

import { GoDash, GoPlus } from 'react-icons/go';

import { formateBrPrice } from '../../../../utils/formateBrPrice';

import * as S from './styles';
import { ISelectedComplement } from '../ModalProduct';

interface ComplementItemProps {
  item: any;
  handleSelectedComplement: (cartComponent: ISelectedComplement) => void;
  full: boolean;
  cartComplement?: any;
}

const ComplementItem: React.FC<ComplementItemProps> = (props) => {
  const { item, handleSelectedComplement, full, cartComplement } = props;

  const [quantityMax, setQuantityMax] = useState(false);
  const [complementMin, setComplementMin] = useState(false);
  const [quantity, setQuantity] = useState(
    cartComplement?.quantidade ?? +item.minimumQuantity ?? 0,
  );

  const handleAdition = useCallback((): void => {
    setQuantity(+quantity + 1);
  }, [quantity]);

  const handleRemove = useCallback((): void => {
    if (quantity > 0) setQuantity(+quantity - 1);
  }, [quantity]);

  useEffect(() => {
    handleSelectedComplement({ complement: item, quantity });

    if (quantity >= item.maximumQuantity) {
      setQuantityMax(true);
    } else {
      setQuantityMax(false);
    }

    if (quantity <= item.minimumQuantity) {
      setComplementMin(true);
    } else {
      setComplementMin(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity]);

  return (
    <S.ComplementItem>
      <div className="informations">
        <p>{item.name}</p>
        {Number(item.price.value) === 0 ? (
          <div />
        ) : (
          <p className="price">{formateBrPrice(+item.price.value)}</p>
        )}
      </div>
      <S.Quantidade>
        <S.CustomIconButton
          size="small"
          disabled={complementMin}
          onClick={handleRemove}
        >
          <GoDash />
        </S.CustomIconButton>
        <label>{quantity}</label>
        <S.CustomIconButton
          size="small"
          disabled={full || quantityMax}
          onClick={handleAdition}
        >
          <GoPlus />
        </S.CustomIconButton>
      </S.Quantidade>
    </S.ComplementItem>
  );
};

export default ComplementItem;
